// No navegador o relatório é baixado pelo próprio navegador; o histórico fica só no celular.
import type { AbaId } from '../store/types';
export type Relatorio = { id: string; nome: string; mime: string; aba: AbaId | 'geral'; criado: string; tamanho: number; uri?: string; url?: string; doApp?: boolean };
export const marcarAbaAtual = (_id: AbaId | 'geral') => {};
export const useRelatorios = (_aba?: AbaId): Relatorio[] => [];
export const relatoriosCarregados = () => true;
export function pedirRelatorio(_id: string | null) {}
export const usePedidoRelatorio = (): string | null => null;
export function registrarRelatorio(_r: Omit<Relatorio, 'id' | 'criado' | 'aba'> & { aba?: AbaId | 'geral' }) {}
export function tirarRelatorio(_id: string) {}
export async function abrirRelatorio(_r: Relatorio) {}
